import { Skeleton } from "@/components/ui/skeleton";

interface LoadingProps {
  count?: number;
  className?: string;
}

export function Loading({ count = 10, className = "" }: LoadingProps) {
  return (
    <div className={`w-full space-y-4 ${className}`}>
      <div className="flex items-center justify-start gap-4">
        {/* <Skeleton className="h-12 w-12 rounded-full bg-stone-200" /> */}
        <Skeleton className="h-6 w-[150px] bg-stone-200" />
      </div>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="h-4 w-full lg:w-2/3 bg-stone-200" />
          <Skeleton className="h-4 w-full lg:w-1/2 bg-stone-200" />
          <Skeleton className="h-4 w-[200px] bg-stone-200" />
        </div>
      ))}
    </div>
  );
}
